import styled from "styled-components";

export const SelectAssetBannerStyled = styled.div`
    display: flex;
    align-items: center;
    padding: 16px;
    border-radius: 16px;
    gap: 12px;
    background: var(--gradient-primary);
    color: var(--color-label-primary-inverted);
    
    .title {
        font-size: 20px;
        line-height: 28px;
    }
    
    .info {
        flex: 1;
    }
    
    .description {
        font-size: 14px;
        line-height: 24px;
        color: var(--color-label-neutral-primary-black);
    }
`;
